module.exports = __webpack_public_path__ + "img/T1B_rc_12.26a9f7ae.png";